<template>
    <div class="row page">
        <div class="establishments">

            <div v-if="isSetupComplete && !addingEstablishment">
                <div v-if="pendingEstablishments.length > 0" class="establishments-pending">
                    <h2>Pending</h2>
                    <ul class="establishment-list">
                        <li v-for="establishment in pendingEstablishments"
                            v-bind:key="establishment.name"
                            class="row">
                            <div class="col-4">
                                <div class="establishment-list__thumbnail">
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="row">
                                    <h3 class="col-12">{{establishment.name}}</h3>
                                </div>
                                <div class="row">
                                    <div class="col-8 offset-4">
                                        <button v-on:click="addPendingEstablishment(establishment.reference)" class="btn btn-primary">
                                            <i class="fas fa-plus"></i>
                                            Add
                                        </button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-8 offset-4">
                                        <button v-on:click.stop="archiveEstablishment(establishment.reference)" class="btn btn-secondary">
                                            <i class="fas fa-archive"></i>
                                            Archive
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <div v-show="waiting">
                            <Spinner/>
                        </div>
                        <div v-if="error" class="alert alert-danger" role="alert">
                            {{error}}
                        </div>
                        <div v-if="success" class="alert alert-success" role="alert">
                            {{success}}
                        </div>
                    </ul>
                </div>

                <h2 class="d-none d-lg-inline">Establishments</h2>
                <ul class="establishment-list">
                    <li v-for="establishment in establishments"
                        v-bind:key="establishment.name"
                        v-bind:class="{'establishment--disabled' : establishment.state === 'inactive'}"
                        class="row">
                        <div class="establishment__state-sticker--disabled" v-if="establishment.state === 'inactive'">
                            <i class="fas fa-cogs"></i>
                            Automations turned off
                        </div>
                        <h3 class="col-12 establishment__name">{{establishment.name}}</h3>
                        <div class="col-12">
                            <div v-show="waiting">
                                <Spinner/>
                            </div>
                            <div v-if="error" class="alert alert-danger" role="alert">
                                {{error}}
                            </div>
                            <div v-if="success" class="alert alert-success" role="alert">
                                {{success}}
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="establishment-list__thumbnail" v-bind:class="{'establishment-list__thumbnail--image' : establishment.preferences.images.length > 0}">
                                <img v-if="establishment.preferences.images.length > 0" 
                                     v-bind:src="establishment.preferences.images[0].url"/>
                                <i v-else class="fas fa-house-user"></i>
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="row">
                                <div class="col-12 col-12 col-sm-9 offset-sm-3 col-md-8 offset-md-4">
                                    <template v-if="establishment.state === 'active'">
                                        <button v-on:click.stop="confirmDeactivateEstablishment(establishment)" class="btn btn-normal establishment__state-button--active">
                                            <i class="fas fa-pause"></i>
                                            Disable
                                        </button>
                                    </template>
                                    <template v-if="establishment.state === 'inactive'">
                                        <button v-on:click.stop="confirmActivateEstablishment(establishment)" class="btn btn-normal establishment__state-button--inactive">
                                            <i class="fas fa-play"></i>
                                            Enable
                                        </button>
                                    </template>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-12 col-sm-9 offset-sm-3 col-md-8 offset-md-4">
                                    <button v-on:click.stop="editSettings(establishment)" class="btn btn-normal">
                                        <i class="fas fa-cog"></i>
                                        Settings
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-12 col-sm-9 offset-sm-3 col-md-8 offset-md-4">
                                    <button v-on:click.stop="editFiles(establishment)" class="btn btn-normal">
                                        <i class="fas fa-file-image"></i>
                                        Files
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-12 col-sm-9 offset-sm-3 col-md-8 offset-md-4">
                                    <button v-on:click.stop="editAppearance(establishment)" class="btn btn-normal">
                                        <i class="fas fa-image"></i>
                                        Appearance
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-12 col-sm-9 offset-sm-3 col-md-8 offset-md-4">
                                    <button v-on:click.stop="configureWhatsApp(establishment)" v-bind:disabled="!canShowWhatsApp" class="btn btn-normal">
                                        <i class="fas fa-comments"></i>
                                        WhatsApp
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-12 col-sm-9 offset-sm-3 col-md-8 offset-md-4">
                                    <button v-on:click.stop="editUpsell(establishment)" class="btn btn-normal">
                                        <i class="fas fa-cart-plus"></i>
                                        Upsell
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-12 col-sm-9 offset-sm-3 col-md-8 offset-md-4">
                                    <button v-on:click.stop="editVariables(establishment)" class="btn btn-normal">
                                        <span class="establishment-list__personalisation-icon">${...}</span>
                                        Personalisation
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-12 col-sm-9 offset-sm-3 col-md-8 offset-md-4">
                                    <button v-on:click.stop="editOTAs(establishment)" class="btn btn-normal">
                                        <i class="fas fa-hands-helping"></i>
                                        Agents
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-12 col-sm-9 offset-sm-3 col-md-8 offset-md-4">
                                    <button v-on:click.stop="editFrontDesk(establishment)" class="btn btn-normal">
                                        <i class="fas fa-concierge-bell"></i>
                                        Front desk
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-12 col-sm-9 offset-sm-3 col-md-8 offset-md-4">
                                    <button v-on:click.stop="showDetails(establishment)" class="btn btn-normal">
                                        <i class="fas fa-info-circle"></i>
                                        Details
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-12 col-sm-9 offset-sm-3 col-md-8 offset-md-4">
                                    <button v-on:click.stop="confirmArchiveEstablishment(establishment)" class="btn btn-normal">
                                        <i class="fas fa-archive"></i>
                                        Archive
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <h3 class="col-12 room-types-heading">{{getUnitTypeForDisplay}}</h3>
                            </div>
                        </div>
                        <div class="col-12">
                            <ul class="room-types-list">
                                <li v-for="(roomType, index) of establishment.roomTypes" v-bind:key="index">
                                    <div class="row">
                                        <div class="col-12 room-type-name">
                                            <div>
                                                <i v-bind:class="getUnitIconForDisplay" aria-hidden="true"></i> <h5>{{roomType.name}}</h5>
                                            </div>
                                            <div v-if="hasIntegrations">
                                                <input type="text" v-bind:value="roomType.mappedId" placeholder="Breezeway ID" v-on:change="updateMappedRoomTypeId(establishment.reference, roomType.reference, $event)"/>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>

                <button v-on:click="toggleAddEstablishment()" class="btn btn-secondary">
                    <i class="fas fa-plus"></i>
                    Add Establishment
                </button>
            </div>





            <div v-if="addingEstablishment" class="form-account form-add-establishment">

                <div v-if="isSetupComplete" class="form-account__welcome">
                    <i class="fas fa-house-user"></i> <h5>Quickly update your places</h5>
                    <h1>Add another establishment</h1>
                    <h5>Add your establishment and setup communication</h5>
                </div>

                <div v-else class="form-account__welcome">
                    <i class="fas fa-running"></i> <h5>Almost there {{username}}</h5>
                    <h1>Let's finish setting up</h1>
                    <h5>Add your establishment and setup communication</h5>
                </div>

                <form v-on:submit.prevent="addEstablishment()">
                    <ul>
                        <li>
                            <label for="name">Establishment name</label>
                            <input v-model="name" id="name" type="text" class="form-account__text">
                        </li>
<!--                        <li>-->
<!--                            <label for="communication">Will you handle communication for this place?</label>-->
<!--                            <input type="checkbox" id="communication" v-model="myContactDetails" true-value="true" false-value="false"/>{{option}}-->
<!--                            Yes, use my contact details-->
<!--                            <div class="form-account__note">Will you send out check-in forms and communicate with guests?</div>-->
<!--                        </li>-->
    <!--                    <li>-->
    <!--                        <label for="email">Email address</label>-->
    <!--                        <input id="email" type="text" class="form-account__email">-->
    <!--                    </li>-->
    <!--                    <li>-->
    <!--                        <label for="usesPMS">Are you a NightsBridge customer?</label>-->
    <!--                        <input id="usesPMS" type="text" class="form-account__email">-->
    <!--                    </li>-->
    <!--                    <li>-->
    <!--                        <label for="pmsID">What is your BBID?</label>-->
    <!--                        <input id="pmsID" type="text" class="form-account__email">-->
    <!--                    </li>-->
                    </ul>
                    <div v-if="error" class="alert alert-danger" role="alert">
                        {{error}}
                    </div>
                    <div v-if="success" class="alert alert-success" role="alert">
                        {{success}}
                    </div>
                    <div v-show="waiting">
                        <Spinner/>
                    </div>
                    <div v-show="!waiting">
                        <button v-show="!establishmentAdded" class="btn btn-primary">Add establishment</button>
                        <router-link to="/tasks" v-show="establishmentAdded" tag="button" class="btn btn-primary" v-on:click.native="$root.$emit('setup-complete')">Get started</router-link>
                        <button v-if="establishments.length > 1" v-on:click="toggleAddEstablishment()" class="btn btn-secondary">Cancel</button>
                    </div>
                </form>
            </div>

<!--            <EditMode v-if="editingMode" v-bind:establishment="establishmentToEdit"/>-->
            <edit-settings v-if="editingSettings" v-bind:establishment="establishmentToEdit"/>
            <edit-files v-if="editingFiles" v-bind:establishment="establishmentToEdit"/>
            <edit-appearance v-if="editingAppearance" v-bind:establishment="establishmentToEdit"/>
            <configure-whats-app v-if="configuringWhatsApp" v-bind:establishment="establishmentToEdit"/>
            <configure-upsell v-if="editingUpsell" v-bind:establishment="establishmentToEdit"/>
            <edit-variables v-if="editingVariables" v-bind:establishment="establishmentToEdit"/>
            <edit-o-t-as v-if="editingOTAs" v-bind:establishment="establishmentToEdit"/>
            <edit-front-desk v-if="editingFrontDesk" v-bind:establishment="establishmentToEdit"/>
            <establishment-details v-if="showingDetails" v-bind:establishment="establishmentToEdit"/>
        </div>

        <confirm-dialog v-bind:message="confirmDeactivateMessage" 
                        v-bind:callbackPrimaryName="'deactivate-establishment'" 
                        v-bind:callbackPrimaryReference="establishmentToEdit.reference" 
                        v-if="showConfirmDeactivateDialog"/>
        <confirm-dialog v-bind:message="confirmActivateMessage" 
                        v-bind:callbackPrimaryName="'activate-establishment'" 
                        v-bind:callbackPrimaryReference="establishmentToEdit.reference" 
                        v-if="showConfirmActivateDialog"/>
        <confirm-dialog v-bind:message="confirmArchiveMessage" 
                        v-bind:callbackPrimaryName="'archive-establishment'" 
                        v-bind:callbackPrimaryReference="establishmentToEdit.reference" 
                        v-if="showConfirmArchiveDialog"/>
    </div>
</template>

<script>
    import Vue from 'vue'
    
    // import EditMode from '../components/establishments/EditMode'
    import EditSettings from '../components/establishments/EditSettings'
    import EditFiles from '../components/establishments/EditFiles'
    import EditAppearance from '../components/establishments/EditAppearance'
    import ConfigureWhatsApp from '../components/establishments/ConfigureWhatsApp'
    import ConfigureUpsell from '../components/establishments/ConfigureUpsell'
    import EditVariables from '../components/establishments/EditVariables'
    import EditOTAs from '../components/establishments/EditAgents'
    import EditFrontDesk from '../components/establishments/EditFrontDesk'
    import EstablishmentDetails from '../components/establishments/EstablishmentDetails'
    import Spinner from '../components/Spinner.vue'
    import ConfirmDialog from '../components/ConfirmDialog.vue'
    import { store, mutations, getters } from '@/store.js'

    export default {
        name: "ListEstablishments.vue",
        components: { EditSettings, EditFiles, EditAppearance, ConfigureWhatsApp, ConfigureUpsell, EditVariables, EditOTAs, EditFrontDesk, EstablishmentDetails, Spinner, ConfirmDialog },
        data: function () {
            return {
                pendingEstablishments: [],
                addingEstablishment: false,
                showConfirmDeactivateDialog: false,
                showConfirmActivateDialog: false,
                editingSettings: false,
                editingFiles: false,
                editingAppearance: false,
                configuringWhatsApp: false,
                editingUpsell: false,
                editingVariables: false,
                editingOTAs: false,
                editingFrontDesk: false,
                showingDetails: false,
                showConfirmArchiveDialog: false,
                establishmentToEdit: null,
                establishmentAdded: false,
                waiting: false,
                name: "",
                myContactDetails: true,
                error: null,
                success: null,
            }
        },
        computed: {
            establishments: function () {
                return store.host.establishments
            },
            username: function () {
                return store.host.name
            },
            isSetupComplete: function() {
                return (this.establishments !== undefined && this.establishments.length > 0)
            },
            getUnitIconForDisplay: function () {
                switch (getters.getCurrentEstablishment().preferences.displayCategoryForRoomTypes) {
                    case 'property':
                        return 'fas fa-home'
                    case 'unit':
                        return 'fas fa-home'
                    case 'room':
                    default:
                        return 'fas fa-bed'
                }
            },
            getUnitTypeForDisplay: function() {
                return getters.getCurrentEstablishment().preferences.displayCategoryForRoomTypes;
            },
            confirmDeactivateMessage: function() {
                return "Are you sure you want to <b>disable the establishment '" + this.establishmentToEdit.name + "'</b>? New bookings and events " +
                    "will NOT trigger automations and scheduled (future) tasks will be paused. Do you wish to continue?";
            },
            confirmActivateMessage: function() {
                return "Are you sure you want to <b>enable the establishment '" + this.establishmentToEdit.name + "'</b>? New bookings and events " +
                    "will trigger automations and scheduled (future) tasks will take place as scheduled. Do you wish to continue?";
            },
            confirmArchiveMessage: function() {
                return "Are you sure you want to <b>archive the establishment '" + this.establishmentToEdit.name + "'</b>?";
            },
            hasIntegrations: function() {
                return store.hasIntegrations;
            },
            canShowWhatsApp: function() {
                return getters.canShowWhatsApp();
            },
        },
        methods: {
            toggleAddEstablishment: function () {
                this.error = null;
                this.success = null;
                this.addingEstablishment = !this.addingEstablishment
            },
            addEstablishment: function () {
                this.error = null;
                this.success = null;
                this.establishmentAdded = false;
                this.waiting = true;
                const body = {
                    name: this.name
                }
                this.$http.post('/guest-management/v1/establishments', body
                ).then(response => {
                    mutations.addEstablishment(response.data);
                    mutations.setCurrentEstablishmentReference(response.data.reference);
                    this.success = this.name + " added";
                    this.establishmentAdded = true;
                    if (this.establishments.length > 1) {
                        this.addingEstablishment = false
                    }
                    // this.toggleAddEstablishment();
                }).catch(error => {
                    if (error.response) {
                        this.error = error.response.data.message
                    } else {
                        this.error = "An unknown error occurred while trying to add an establishment"
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.waiting = false
                    }, 500)
                })
            },
            checkForPendingEstablishments: function() {
                console.log("Checking for pending establishments");
                this.$http.get('/guest-management/v1/establishments/pending'
                ).then(response => {
                    this.pendingEstablishments = response.data;
                }).catch(error => {
                    if (error.response) {
                        this.error = error.response.data.message
                    } else {
                        this.error = "An unknown error occurred while trying to fetch pending establishments"
                    }
                });
            },
            addPendingEstablishment: function(reference) {
                console.log("Adding pending establishment with reference: " + reference);
                this.waiting = true;
                this.$http.post('/guest-management/v1/establishments/pending/' + reference + "/add").then(response => {
                    mutations.addEstablishment(response.data);
                    this.success = response.data.name + " added";
                    this.pendingEstablishments = this.pendingEstablishments.filter(e => e.reference !== reference);
                }).catch(error => {
                    if (error.response) {
                        this.error = error.response.data.message
                    } else {
                        this.error = "An unknown error occurred while trying to add a pending establishment"
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.waiting = false
                    }, 500)
                })
            },
            confirmDeactivateEstablishment: function(establishment) {
                this.establishmentToEdit = establishment;
                this.showConfirmDeactivateDialog = true;
            },
            syncedEstablishmentDetails: function(reference) {
                for (let establishment of this.establishments) {
                    if (establishment.reference === reference) {
                        this.establishmentToEdit = establishment;
                        return;
                    }
                }
            },
            deactivateEstablishment: function(reference) {
                this.showConfirmDeactivateDialog = false;
                if (this.establishmentToEdit.reference === reference) {
                    console.log("Deactivating establishment with reference: " + reference);
                    this.waiting = true;
                    this.$http.put('/guest-management/v1/establishments/' + reference + "/state/inactive"
                    ).then(() => {
                        let establishment = getters.getEstablishmentByReference(reference);
                        if (establishment !== null) {
                            establishment.state = "inactive";
                            this.success = establishment.name + " has been deactivated"
                        }
                    }).catch(error => {
                        if (error.response) {
                            this.error = error.response.data.message
                        } else {
                            this.error = "An unknown error occurred while trying to deactivate an establishment"
                        }
                    }).finally(() => {
                        this.waiting = false;
                        setTimeout(() => {
                            this.error = null;
                            this.success = null;
                        }, 2000)
                    })
                }
            },
            confirmActivateEstablishment: function(establishment) {
                this.establishmentToEdit = establishment;
                this.showConfirmActivateDialog = true;
            },
            activateEstablishment: function(reference) {
                this.showConfirmActivateDialog = false;
                if (this.establishmentToEdit.reference === reference) {
                    console.log("Activating establishment with reference: " + reference);
                    this.waiting = true;
                    this.$http.put('/guest-management/v1/establishments/' + reference + "/state/active"
                    ).then(() => {
                        let establishment = getters.getEstablishmentByReference(reference);
                        if (establishment !== null) {
                            establishment.state = "active";
                            this.success = establishment.name + " has been activated"
                        }
                    }).catch(error => {
                        if (error.response) {
                            this.error = error.response.data.message
                        } else {
                            this.error = "An unknown error occurred while trying to activate an establishment"
                        }
                    }).finally(() => {
                        this.waiting = false;
                        setTimeout(() => {
                            this.error = null;
                            this.success = null;
                        }, 2000)
                    })
                }
            },
            editSettings: function(establishment) {
                this.establishmentToEdit = establishment;
                this.editingSettings = true;
            },
            stopEditingSettings: function() {
                this.editingSettings = false;
            },
            editFiles: function(establishment) {
                this.establishmentToEdit = establishment;
                this.editingFiles = true;
            },
            stopEditingFiles: function() {
                this.editingFiles = false;
            },
            editAppearance: function(establishment) {
                this.establishmentToEdit = establishment;
                this.editingAppearance = true;
            },
            stopEditingAppearance: function() {
                this.editingAppearance = false;
            },
            configureWhatsApp: function(establishment) {
                this.establishmentToEdit = establishment;
                this.configuringWhatsApp = true;
            },
            stopConfiguringWhatsApp: function() {
                this.configuringWhatsApp = false;
            },
            editUpsell: function(establishment) {
                this.establishmentToEdit = establishment;
                this.editingUpsell = true;
            },
            stopEditingUpsell: function() {
                this.editingUpsell = false;
            },
            editVariables: function(establishment) {
                this.establishmentToEdit = establishment;
                this.editingVariables = true;
            },
            stopEditingVariables: function() {
                this.editingVariables = false;
            },
            editOTAs: function(establishment) {
                this.establishmentToEdit = establishment;
                this.editingOTAs = true;
            },
            stopEditingOTAs: function() {
                this.editingOTAs = false;
            },
            editFrontDesk: function(establishment) {
                this.establishmentToEdit = establishment;
                this.editingFrontDesk = true;
            },
            stopEditingFrontDesk: function() {
                this.editingFrontDesk = false;
            },
            showDetails: function(establishment) {
                this.establishmentToEdit = establishment;
                this.showingDetails = true;
            },
            stopShowingDetails: function() {
                this.showingDetails = false;
            },
            selectEstablishment: function(reference) {
                mutations.setCurrentEstablishmentReference(reference);
                this.$router.push({ name: 'TaskCalendar' })
            },
            confirmArchiveEstablishment: function(establishment) {
                this.establishmentToEdit = establishment;
                this.showConfirmArchiveDialog = true;
            },
            archiveEstablishment: function(reference) {
                this.showConfirmArchiveDialog = false;
                if (this.establishmentToEdit.reference === reference) {
                    console.log("Archiving establishment with reference: " + reference);
                    this.$http.put('/guest-management/v1/establishments/' + reference + "/state/archived"
                    ).then(() => {
                        let establishment = getters.getEstablishmentByReference(reference);
                        if (establishment !== null) {
                            mutations.removeEstablishment(reference);
                            this.success = establishment.name + " removed"
                        }
                        if (this.establishments.length == 0) {
                            this.addingEstablishment = true
                        }
                    }).catch(error => {
                        if (error.response) {
                            this.error = error.response.data.message
                        } else {
                            this.error = "An unknown error occurred while trying to archive an establishment"
                        }
                    }).finally(() => {
                        setTimeout(() => {
                            this.waiting = false
                        }, 500)
                    })
                }
            },
            fetchRoomTypeMappings: function() {
                console.log("Fetch room type mappings");
                this.$http.get('/guest-management/v1/companies/' + store.host.company.reference + '/integrations', {
                    withCredentials: true
                }).then(response => {
                    let integrations = response.data;
                    for (let integration of integrations) {
                        if (integration.type === "breezeway") {
                            this.fetchRoomTypeMappingsForBreezeway();
                        }
                    }
                }).catch(error => {
                    if (error.response) {
                        this.error = error.response.data.message
                    } else {
                        this.error = "An unknown error occurred while trying to fetch integrations"
                    }
                });
            },
            fetchRoomTypeMappingsForBreezeway: function() {
                console.log("Fetch room type mappings for Breezeway");
                this.$http.get('/guest-management/v1/companies/' + store.host.company.reference + '/integrations/breezeway/room-type-mappings', {
                    withCredentials: true
                }).then(response => {
                    let roomTypeMappingsArray = response.data;
                    let roomTypeMappingsMap = roomTypeMappingsArray.reduce((map, obj) => {
                        map[obj.roomTypeReference] = obj;
                        return map;
                    }, {});
                    for (let establishment of this.establishments) {
                        for (let roomType of establishment.roomTypes) {
                            if (roomTypeMappingsMap[roomType.reference]) {
                                Vue.set(roomType, 'mappedId', roomTypeMappingsMap[roomType.reference].externalId);
                            }
                        }
                    }
                }).catch(error => {
                    if (error.response) {
                        this.error = error.response.data.message
                    } else {
                        this.error = "An unknown error occurred while trying to fetch room type mappings"
                    }
                });
            },
            updateMappedRoomTypeId: function(establishmentReference, roomTypeReference, event) {
                console.log("Updating room type mapping: " + establishmentReference + " - " + roomTypeReference + " - " + event.target.value);
                const body = {
                    integrationType: "breezeway",
                    reference: roomTypeReference,
                    externalId: event.target.value,
                }
                this.$http.put('/guest-management/v1/establishments/' + establishmentReference + "/room-types/" + roomTypeReference + "/map", body
                ).then(() => {
                }).catch(error => {
                    if (error.response) {
                        this.error = error.response.data.message
                    } else {
                        this.error = "An unknown error occurred while trying to update room type mapping"
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.waiting = false
                    }, 500)
                })

            }
        },
        mounted() {
            if (!this.isSetupComplete) {
                this.addingEstablishment = true
            }

            this.$root.$on('finished-editing-establishment-settings', this.stopEditingSettings);
            this.$root.$on('finished-editing-establishment-files', this.stopEditingFiles);
            this.$root.$on('finished-editing-establishment-appearance', this.stopEditingAppearance);
            this.$root.$on('finished-editing-whatsapp', this.stopConfiguringWhatsApp);
            this.$root.$on('finished-editing-upsell', this.stopEditingUpsell);
            this.$root.$on('finished-editing-establishment-variables', this.stopEditingVariables);
            this.$root.$on('finished-editing-establishment-agents', this.stopEditingOTAs);
            this.$root.$on('finished-editing-establishment-front-desk', this.stopEditingFrontDesk);
            this.$root.$on('close-establishment-details', this.stopShowingDetails);

            this.$root.$on('synced-establishment-details', this.syncedEstablishmentDetails);
            this.$root.$on('deactivate-establishment', this.deactivateEstablishment);
            this.$root.$on('activate-establishment', this.activateEstablishment);
            this.$root.$on('archive-establishment', this.archiveEstablishment);

            this.checkForPendingEstablishments();
            this.fetchRoomTypeMappings();
        },
        beforeDestroy () {
            this.$root.$off('finished-editing-establishment-settings', this.stopEditingSettings);
            this.$root.$off('finished-editing-establishment-files', this.stopEditingFiles);
            this.$root.$off('finished-editing-establishment-appearance', this.stopEditingAppearance);
            this.$root.$off('finished-editing-whatsapp', this.stopConfiguringWhatsApp);
            this.$root.$off('finished-editing-upsell', this.stopEditingUpsell);
            this.$root.$off('finished-editing-establishment-variables', this.stopEditingVariables);
            this.$root.$off('finished-editing-establishment-agents', this.stopEditingOTAs);
            this.$root.$off('finished-editing-establishment-front-desk', this.stopEditingFrontDesk);
            this.$root.$off('close-establishment-details', this.stopShowingDetails);

            this.$root.$off('synced-establishment-details', this.syncedEstablishmentDetails);
            this.$root.$off('deactivate-establishment', this.deactivateEstablishment);
            this.$root.$off('activate-establishment', this.activateEstablishment);
            this.$root.$off('archive-establishment', this.archiveEstablishment);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/pages/list-establishments";
</style>